import React, { useEffect } from 'react'

import {
  CONTACT_EMAIL,
  CONTACT_PHONE,
  CONTACT_PHONE_DISPLAY,
} from '../../constants'

const Contact: React.FC = () => {
  useEffect(() => {
    const widgetScriptSrc = 'https://tally.so/widgets/embed.js'

    const load = () => {
      if (typeof window.Tally !== 'undefined') {
        window.Tally.loadEmbeds()
        return
      }

      document
        .querySelectorAll('iframe[data-tally-src]:not([src])')
        .forEach((iframeEl: Element) => {
          const iframe = iframeEl as HTMLIFrameElement
          iframe.src = iframe.dataset.tallySrc || ''
        })
    }

    if (typeof window.Tally !== 'undefined') {
      load()
      return
    }

    if (document.querySelector(`script[src="${widgetScriptSrc}"]`) === null) {
      const script = document.createElement('script')
      script.src = widgetScriptSrc
      script.onload = load
      script.onerror = load
      document.body.appendChild(script)
      return
    }
  }, [])

  return (
    <section id="contact" className="py-12 bg-brand-primary">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-10">
          {/* Left - Contact Info */}
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-brand-ink mb-4">
              Contact
            </h2>
            <p className="text-sm md:text-base text-brand-muted mb-6 leading-relaxed">
              Heb je een vraag, wil je een offerte of gewoon even sparren over
              je IT-situatie? Neem gerust contact op. Ik reageer snel en
              vrijblijvend.
            </p>

            <div className="space-y-3 mb-6">
              <div className="flex items-start gap-3">
                <div className="flex-shrink-0 w-5 h-5 text-brand-accent mt-1">
                  <svg fill="currentColor" viewBox="0 0 20 20">
                    <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                    <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                  </svg>
                </div>
                <div>
                  <p className="text-sm font-semibold text-brand-ink">E-mail</p>
                  <a
                    href={`mailto:${CONTACT_EMAIL}`}
                    className="text-sm text-brand-accent hover:text-brand-accent/80 transition-colors"
                  >
                    {CONTACT_EMAIL}
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="flex-shrink-0 w-5 h-5 text-brand-accent mt-1">
                  <svg fill="currentColor" viewBox="0 0 20 20">
                    <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                  </svg>
                </div>
                <div>
                  <p className="text-sm font-semibold text-brand-ink">
                    Telefoon
                  </p>
                  <a
                    href={`tel:${CONTACT_PHONE}`}
                    className="text-sm text-brand-accent hover:text-brand-accent/80 transition-colors"
                  >
                    {CONTACT_PHONE_DISPLAY}
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Right - Tally Contact Form */}
          <div className="bg-brand-surface rounded-xl p-6 border border-brand-ink/10">
            <h3 className="text-lg md:text-xl font-bold text-brand-accent mb-4">
              Snel contact
            </h3>
            <iframe
              data-tally-src="https://tally.so/embed/wA1bQl?alignLeft=1&hideTitle=1&transparentBackground=1&dynamicHeight=1"
              loading="lazy"
              width="100%"
              height="540"
              frameBorder={0}
              marginHeight={0}
              marginWidth={0}
              title="Snel Contact"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Contact
